import { PHONE_TEL, SERVICES } from "@/data/site";

const WideCard = ({ service, idx }) => (
  <div className="rounded-2xl bg-slate-900/60 border border-slate-800 overflow-hidden sm:col-span-2 lg:col-span-3" data-testid={`service-card-${idx + 1}`}>
    <div className="flex flex-col sm:flex-row sm:items-center gap-6">
      <div className="sm:w-72 h-44 sm:h-auto sm:self-stretch shrink-0">
        <img src={service.img} alt={service.name} loading="lazy" className="w-full h-full object-cover" data-testid={`service-image-${idx + 1}`} />
      </div>
      <div className="flex-1 p-6 sm:py-6 sm:pl-0">
        <div className="flex items-center gap-3">
          <span className="text-[11px] font-semibold text-rose-400 uppercase">{service.category}</span>
          <span className="text-[11px] text-slate-500">&bull; {service.duration}</span>
        </div>
        <h3 className="text-xl font-bold text-white mt-1">{service.name}</h3>
        <p className="text-xs text-slate-400 mt-1 max-w-2xl leading-relaxed">{service.desc}</p>
        <ul className="mt-3 flex flex-wrap gap-2">
          {service.includes.map((item) => (
            <li key={item} className="text-[11px] text-slate-300 bg-slate-950 border border-slate-800 rounded-lg px-2.5 py-1">{item}</li>
          ))}
          <li className="text-[11px] text-rose-300 bg-rose-500/10 border border-rose-500/30 rounded-lg px-2.5 py-1" data-testid={`service-price-${idx + 1}`}>{service.price || "Call for price"}</li>
        </ul>
      </div>
      <a href="#contact" data-testid="service-book-beard-btn" className="self-start sm:self-center mx-6 mb-6 sm:m-0 sm:mr-6 px-6 py-3 bg-rose-600/20 border border-rose-500/40 text-rose-300 text-xs uppercase font-bold rounded-xl hover:bg-rose-600 hover:text-white transition-colors shrink-0">
        Book Beard Trim &rarr;
      </a>
    </div>
  </div>
);

const Card = ({ service, idx }) => (
  <div className="rounded-2xl bg-slate-900/60 border border-slate-800 overflow-hidden flex flex-col justify-between" data-testid={`service-card-${idx + 1}`}>
    <div>
      <div className="h-36 overflow-hidden">
        <img src={service.img} alt={service.name} loading="lazy" className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" data-testid={`service-image-${idx + 1}`} />
      </div>
      <div className="p-6 pb-0">
        <div className="flex items-center gap-3">
          <span className="text-[11px] font-semibold text-rose-400 uppercase">{service.category}</span>
          <span className="text-[11px] text-slate-500">&bull; {service.duration}</span>
        </div>
        <h3 className="text-lg font-bold text-white mt-1">{service.name}</h3>
        <p className="text-xs text-slate-400 mt-2 leading-relaxed">{service.desc}</p>
        <ul className="mt-3 space-y-1.5">
          {service.includes.map((item) => (
            <li key={item} className="text-[11px] text-slate-300 flex items-center gap-2"><span className="text-rose-400">&bull;</span>{item}</li>
          ))}
        </ul>
      </div>
    </div>
    <div className="m-6 mt-4 pt-4 border-t border-slate-800/80 flex items-center justify-between">
      <span className="text-xs text-slate-500">Unisex &bull; <a href={PHONE_TEL} className="text-rose-400/90 hover:text-rose-300 transition-colors" data-testid={`service-price-${idx + 1}`}>{service.price || "Call for price"}</a></span>
      <a href="#contact" data-testid={`service-select-btn-${idx + 1}`} className="text-xs text-rose-400 font-bold hover:underline">Select &rarr;</a>
    </div>
  </div>
);

export const Services = () => (
  <section id="services-grid" className="py-24 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-testid="services-section">
    <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-16">
      <div>
        <span className="text-xs font-semibold uppercase tracking-widest text-rose-400">Complete Salon Menu</span>
        <h2 className="font-condensed text-3xl sm:text-4xl uppercase text-white mt-2">Services &amp; Treatments</h2>
      </div>
      <p className="text-xs text-slate-400 max-w-sm mt-4 md:mt-0">Available for both men and women. Inquire or book your preferred slot below.</p>
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {SERVICES.map((service, idx) => (service.wide ? <WideCard key={service.name} service={service} idx={idx} /> : <Card key={service.name} service={service} idx={idx} />))}
    </div>
  </section>
);
